import React, { useEffect, useState } from 'react';
import { Outlet, Link, Navigate, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useBookContext } from "../contexts/bookContext";
import {
    BottomNavigation, BottomNavigationAction, Paper,
     AppBar,
    Toolbar, 
    IconButton,
    Typography,
    Button,
    Container,
    Tabs,
    Tab,
    Box,
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
 

import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import LogoutIcon from '@mui/icons-material/Logout';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MenuIcon from '@mui/icons-material/Menu';
import HandymanIcon from '@mui/icons-material/Handyman';



import dayjs from 'dayjs';
import 'dayjs/locale/ko';

import axios from "axios";



function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const AdminLayout = () => {
    let navigate = useNavigate();
    const { userData, isLogin, setLogOut, updateUserInfo, actions } = useBookContext();
    const [value, setValue] = useState('/home');
    const [init, setInit] = useState(true);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const params = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    let paramUserEmail = searchParams.get('userEmail') || undefined;
    let paramUserPw = searchParams.get('userPw') || undefined;
    const paramNoTab = searchParams.get('notab') || "no";
    const queryList = [...searchParams];

//    console.log("mainLayout paramUserEmail :" + paramUserEmail)
//    console.log("mainLayout paramUserPw :" + paramUserPw)


    useEffect(() => {
        if (!paramUserEmail || !paramUserPw) {
            console.log("mainLayOut useEffect checkLogin")
            checkLogin();
        }
    }, [userData]);



    useEffect(() => {
        if (paramUserEmail && paramUserPw) {
            login();
        }

    }, [init]);

    const checkLogin = () => {
//        console.log("mainLayout checkLogin userData : " + JSON.stringify(userData))

        if (!isLogin()) {
//            console.log("mainLayOut 로그인상태아님")
            navigate('/login');
        }            

    }



    const login = async () => {

        try {

            const reqData = {};
            reqData.userEmail = paramUserEmail;
            reqData.userPW = paramUserPw;


            let response = await axios.post("/api/booking/CheckUser", reqData);
            console.log("login result :" + JSON.stringify(response.data))
            if ((response.data.code === 0)) {
                let userInfo = response.data.result;
                var newData = {}
                newData.userEmail = userInfo.userEmail;
                newData.userPhone = userInfo.userPhone;
                newData.userName = userInfo.userName;
                newData.chargeMoney = userInfo.chargeMoney;
                newData.chargeCount = userInfo.chargeCount;
                newData.bonusCount = userInfo.bonusCount;
                newData.userLevel = userInfo.userLevel;
                newData.unlimitUser = userInfo.unlimitUser;
                newData.unlimitSeller = userInfo.unlimitSeller;


                updateUserInfo(newData);
//                console.log("mainLayout save new userdata")
                //                checkLogin();


            }
        } catch (err) {
            console.error(err);
        }

    }



    const logOut = () => {
        paramUserEmail = undefined;
        paramUserPw = undefined;
        setLogOut();
        checkLogin();
    }

    const handleChange = (event, newValue) => {
        console.log("tab goto :"+newValue)
        setValue(newValue);
        if (newValue == 'logout') {
            paramUserEmail = undefined;
            paramUserPw = undefined;
            setLogOut();
            navigate('/login');
        } else {
            navigate(newValue)
        }
    };



    const renderAddCourse = () => {

        console.log("renderAddCourse :"+JSON.stringify(userData))
        if (!userData ) {
            return null;
        }
        if (!userData.chargeMoney && userData.chargeMoney < 1 && userData.unlimitUser < 1) {
            return null;
        }

        console.log("renderAddCourse 222:" + JSON.stringify(userData))


        if (isMobile) { 
            return (
                <Tab label="코스선택" {...a11yProps(1)} icon={<LocationOnIcon />} to='/enrollcourse' value='enrollcourse' />
            )
/*
            return (
                <BottomNavigationAction label="코스선택" icon={<LocationOnIcon />} to='enrollcourse' value='enrollcourse' />
            )
*/
        } else {
            return (
                <Tab label="코스선택" {...a11yProps(1)} icon={<LocationOnIcon />} to='/enrollcourse' value='enrollcourse' />
            )

        }
    }



    const renderRequestCourse = () => {

        if (!userData || !userData.userLevel) {
            return null;
        }

        if (userData.userLevel < 100) {
            return null;
        }


        if (isMobile) {
            return (
                <Tab label="코스설정" {...a11yProps(1)} icon={<LocationOnIcon />} to='/requestCourseList' value='requestCourseList' />
            )
            /*
                        return (
                            <BottomNavigationAction label="코스선택" icon={<LocationOnIcon />} to='enrollcourse' value='enrollcourse' />
                        )
            */
        } else {
            return (
                <Tab label="코스설정" {...a11yProps(1)} icon={<LocationOnIcon />} to='/requestCourseList' value='requestCourseList' />
            )

        }
    }



    const deskTopLayOut = (
        <>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Container maxWidth="md">
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example"
                        textColor="inherit"
                        variant="fullWidth"
                    >
                        <Tab label="사용자" {...a11yProps(1)} icon={<PersonIcon />} to='/userList' value='userList' />
                        <Tab label="유저추가" {...a11yProps(1)} icon={<PersonAddIcon />} to='/enrolluser' value='enrolluser' />
                        {renderRequestCourse()}
                    </Tabs>
                </Container>
            </Box>
            <Outlet />


        </>

    )





    return deskTopLayOut;
}

export default AdminLayout;